import React from 'react';
import { connect } from 'react-redux';
import { addExportConfig, updateExportConfig, destroyExportConfig } from 'services/exports/duck';


class ExportableCalloutWithChange extends React.PureComponent {
    constructor(props) {
        super(props);

        if (!props.exportName) {
            console.warn('ExportableCalloutWithChange: Missing exportName from callout with change'); // eslint-disable-line no-console
        }
    }

    componentDidMount() {
        if (this.props.exportName) {
            this.props.addExportConfig({
                exportName: this.props.exportName,
                type: 'callout-with-change',
                title: this.props.title,
                value: this.props.value,
                deltaVisible: this.props.deltaVisible,
                deltaState: this.props.deltaState,
                description: this.props.description,
                categories: this.props.categories,
                calloutWindow: this.props.calloutWindow
            });
        }
    }

    componentDidUpdate() {
        if (this.props.exportName) {
            this.props.updateExportConfig({
                exportName: this.props.exportName,
                type: 'callout-with-change',
                title: this.props.title,
                value: this.props.value,
                deltaVisible: this.props.deltaVisible,
                deltaState: this.props.deltaState,
                description: this.props.description,
                categories: this.props.categories,
                calloutWindow: this.props.calloutWindow
            });
        }
    }

    componentWillUnmount() {
        if (this.props.exportName) {
            this.props.destroyExportConfig({
                exportName: this.props.exportName
            });
        }
    }

    render() {
        return null;
    }
}


export default connect(null, {
    addExportConfig,
    updateExportConfig,
    destroyExportConfig
})(ExportableCalloutWithChange);



// WEBPACK FOOTER //
// ./src/containers/callouts/ExportableCalloutWithChange.js